import { useWishlist } from '../../context/WishlistContext';
import { useAuth } from '../../context/AuthContext';
import { useSite } from '../../context/SiteContext';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, User, MapPin, ShoppingBag, Menu, X, ChevronDown, Heart } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { navCategories } from '../../data/products';
import './Header.css';

const Header = () => {
  const { siteName } = useSite();
  const [searchQuery, setSearchQuery] = useState('');
  const { user, isAuthenticated, signOut } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { getTotalItems, openCart } = useCart();
  const totalItems = getTotalItems();
  const { getWishlistCount } = useWishlist();
const wishlistCount = getWishlistCount();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/shop?search=${encodeURIComponent(searchQuery)}`;
    }
  };

  return (
    <header className="header">
      <div className="header-top">
        FREE SHIPPING ON ORDERS $49+ | <Link to="/shop">Shop Now</Link>
      </div>

      <div className="header-main">
        <button className="header-mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <Link to="/" className="header-logo">
          <span className="header-logo-text">{siteName}</span>
        </Link>

        <div className="header-search">
          <form onSubmit={handleSearch}>
            <Search className="header-search-icon" />
            <input
              type="text"
              placeholder="Search for products, brands, and more"
              className="header-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form>
        </div>

        <div className="header-actions">
          <Link to="/stores" className="header-action-btn">
            <MapPin className="header-action-icon" />
            <span className="header-action-text">Stores</span>
          </Link>

          <Link to="/wishlist" className="header-action-btn header-wishlist-btn">
  <Heart className="header-action-icon" />
  {wishlistCount > 0 && <span className="header-wishlist-count">{wishlistCount}</span>}
  <span className="header-action-text">Wishlist</span>
</Link>

          {isAuthenticated ? (
  <button onClick={signOut} className="header-action-btn">
    <User className="header-action-icon" />
    <span className="header-action-text">Sign Out</span>
  </button>
) : (
  <Link to="/signin" className="header-action-btn">
    <User className="header-action-icon" />
    <span className="header-action-text">Sign In</span>
  </Link>
)}

          <button onClick={openCart} className="header-action-btn header-cart-btn">
            <ShoppingBag className="header-action-icon" />
            {totalItems > 0 && <span className="header-cart-count">{totalItems}</span>}
            <span className="header-action-text">Bag</span>
          </button>
        </div>
      </div>

      <nav className="header-nav">
        <div className="header-nav-container">
          <ul className="header-nav-list">
            {navCategories.map((category) => (
              <li key={category.id} className="header-nav-item">
                <Link to={`/category/${category.id}`} className="header-nav-link">
                  {category.name}
                  <ChevronDown size={14} />
                </Link>
                <div className="header-nav-dropdown">
                  <ul className="header-nav-dropdown-list">
                    {category.subcategories.map((sub) => (
                      <li key={sub}>
                        <Link to={`/category/${category.id}/${sub.toLowerCase().replace(/\s+/g, '-')}`} className="header-nav-dropdown-item">
                          {sub}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
            <li className="header-nav-item">
              <Link to="/sale" className="header-nav-link sale">
                Sale
                <ChevronDown size={14} />
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
